// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.table > thead > tr th {\n    text-transform: uppercase;\n}", "",{"version":3,"sources":["webpack://./src/assets/css/global.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;AAC7B","sourcesContent":["\n.table > thead > tr th {\n    text-transform: uppercase;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
